import { render, staticRenderFns } from "./AllBooking.vue?vue&type=template&id=605c33e5&scoped=true&"
import script from "./AllBooking.vue?vue&type=script&lang=js&"
export * from "./AllBooking.vue?vue&type=script&lang=js&"
import style0 from "./AllBooking.vue?vue&type=style&index=0&id=605c33e5&prod&lang=scss&scoped=true&"
import style1 from "./AllBooking.vue?vue&type=style&index=1&id=605c33e5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605c33e5",
  null
  
)

export default component.exports